import { MutationKey } from '@shared/config';
import { useMutation } from '@tanstack/react-query';
import { vacancyApi } from '../vacancyApi';
import type { GenerateVacancyRequest } from '../types';

export const useGenerateVacancy = () =>
  useMutation({
    mutationKey: [MutationKey.GENERATE_VACANCY],
    mutationFn: (params: GenerateVacancyRequest) =>
      vacancyApi.generateVacancy(params),
  });
